const channelName = "logout_channel";

export const logoutChannel = new BroadcastChannel(channelName);
